import { ExtendCurrency } from 'src/enums'
import validateCurrencyCode from 'validate-currency-code'

export interface CurrencyFormatterArgs {
  amount: number
  currency?: ExtendCurrency
  maximumFractionDigits?: number
  notation?: 'standard' | 'compact'
  forceHideCurrency?: boolean
  forceShowCurrency?: boolean
}

export type CurrencyFormatter = (args: CurrencyFormatterArgs) => string

export function createCurrencyFormatter(
  locale: string,
  defaultDisplayCurrency: ExtendCurrency,
): CurrencyFormatter {
  return (args: CurrencyFormatterArgs): string => {
    const {
      amount,
      currency = defaultDisplayCurrency,
      maximumFractionDigits = 2,
      notation,
      forceHideCurrency = false,
      forceShowCurrency = false,
    } = args

    const validCurrency = validateCurrencyCode(currency)
      ? currency
      : defaultDisplayCurrency
    const formattedAmount = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: validCurrency,
      maximumFractionDigits,
      minimumFractionDigits: maximumFractionDigits,
      notation,
      currencyDisplay: 'narrowSymbol',
    }).format(amount)

    if (forceShowCurrency) {
      return `${formattedAmount} ${validCurrency}`
    }

    if (forceHideCurrency) {
      return formattedAmount
    }

    return defaultDisplayCurrency !== validCurrency
      ? `${formattedAmount} ${validCurrency}`
      : formattedAmount
  }
}
